import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ResumeParseResponse, ResumeUploadResponse } from '@app/schemas/resume';

interface APIParams {
  base64file: string;
  filename: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResumeUploadService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  parseResume(uploadData: APIParams): Observable<ResumeParseResponse> {
    return this.post<ResumeParseResponse>('parse-resume', uploadData);
  }

  uploadResume(uploadData: APIParams): Observable<ResumeUploadResponse> {
    return this.post<ResumeUploadResponse>('upload-resume', uploadData);
  }

  getResumeData(): Observable<ResumeUploadResponse> {
    return this.get<ResumeUploadResponse>('resume-data');
  }
}
